import { SetState } from 'zustand';
import { IAddBillSlice, IBIllData } from '../interfaces';

const getValidAmount = (amount: number) => {
  if (amount.toString().length > 9) {
    return 0;
  }
  return amount;
};

const createAddBillSlice = (set: SetState<IAddBillSlice>) => ({
  billData: {
    billId: '',
    amount: 0,
    billNumber: '',
    dueDate: new Date(),
    supplierName: '',
    supplierId: '',
    billImageUrl: '',
    documentId: '',
    assetType: '',
    assetName: '',
    paymentReminderData: null,
    recurringPaymentData: null,
  },
  resetAddBillSlice: () => {
    set({
      billData: {
        billId: '',
        amount: 0,
        billNumber: '',
        dueDate: new Date(),
        supplierName: '',
        supplierId: '',
        billImageUrl: '',
        documentId: '',
        assetType: '',
        assetName: '',
        paymentReminderData: null,
        recurringPaymentData: null,
      },
    });
  },
  setBillData: (payload: IBIllData) => {
    payload.amount = getValidAmount(payload.amount);
    set({ billData: payload });
  },
});

export default createAddBillSlice;
